module.exports = __webpack_public_path__ + "img/battery-0.12e0e86e.svg";